import React, { Component, Fragment } from 'react';
import api from '../../../services/api';
import './styles.css';

class Configuration extends Component {

    state = {
        load: false,
        documentTypes: {},
        companyTypes: {},
        idCompanyTypes: null,
        idType: null,
        documentsCompanyTypes: {},
        documentsCompanyTypesId: {},
        documentsChecked: {},
        successDocuments: false,
        functions: {},
        titleDocumentValidate: null,
        idDocumentValidate: null,
        isValidadeCalendar: true,
        updateDate: false,
        updateStatuses: false,
        showConfirmation: false
    }

    componentDidMount() {
        this.loadDocumentTypes();
        this.loadCompanyTypes();
    }

    loadDocumentTypes = async () => {
        this.setState({ load: true });
        const response = await api.get('/document-types?status=1');
        this.setState({ documentTypes: response.data.rows, load: false });
    }

    loadCompanyTypes = async () => {
        this.setState({ load: true });
        const response = await api.get('/company-types?status=1');
        this.setState({ companyTypes: response.data.rows, load: false });
    }

    TypeCompany = (e) => {
        this.setState({ idType: e.target.value, idCompanyTypes: null, documentsCompanyTypesId: {} });
    }

    TypeDocuments = async (e) => {
        await this.setState({ idCompanyTypes: e.target.value });
        this.loadDocumentsDocumentTypes();
    }

    loadDocumentsDocumentTypes = async () => {
        this.setState({ load: true });
        const response = await api.get(`/company-types/${this.state.idCompanyTypes}/documents?DocumentTypeId=${this.state.idType}`);
        this.setState({ documentsCompanyTypes: response.data.data, load: false });
    }

    addListDocuments = async () => {

        this.setState({ load: true, successDocuments: false });
        const response = await api.get(`/documents?DocumentTypeId=${this.state.idType}`);
        this.setState({ documentsCompanyTypesId: response.data.rows, load: false });

        this.loadFunctions();
    }

    loadFunctions = async () => {
        this.setState({ load: true });
        const response = await api.get(`/functions?DocumentTypeId=${this.state.idType}`);
        this.setState({ functions: response.data.rows, load: false });
        if (document.getElementById('functions')) {
            document.getElementById('functions').value = '';
        }
    }

    checkDocument = async (e) => {
        let dChk = document.getElementsByName("documents");
        let docs = { documents: [] };
        for (var i = 0; i < dChk.length; i++) {
            if (dChk[i].checked === true) {
                docs.documents.push({ DocumentId: dChk[i].value });
            }
        }
        this.setState({ documentsChecked: docs });
    }

    submitCheckDocument = async (e) => {
        if (this.state.documentsChecked.documents && this.state.documentsChecked.documents.length) {
            
            this.setState({ load: true });
            
            let response = await api.post(`/company-types/${this.state.idCompanyTypes}/documents`, {
                "documents": this.state.documentsChecked.documents, 
                "type": this.state.idType,
                "updateStatuses": this.state.updateStatuses
            });

            if (response.data.msg) {
                this.setState({ successDocuments: true, load: false, documentsChecked: {}, updateStatuses: false });
            } else {
                this.setState({ successDocuments: false, load: false });
            }

            await this.loadDocumentsDocumentTypes();
            await this.filterDocumentsFunction();
            await this.loadFunctions();
        } else {
            this.setState({ successDocuments: false, load: false });
        }
    }

    deleteDocument = async (e) => {
        await api.delete(`/company-types/${this.state.idCompanyTypes}/documents/${e.target.id}`);
        this.loadDocumentsDocumentTypes();
    }

    filterDocumentsFunction = async (e) => {
        let func = '';
        if (e && e.target.value) {
            func = `&FunctionId=${e.target.value}`;
            this.setState({ successDocuments: false });
        }
        this.setState({ load: true });
        const response = await api.get(`/documents?DocumentTypeId=${this.state.idType}${func}`);
        this.setState({ documentsCompanyTypesId: response.data.rows, load: false });
    }

    verifyDocumentSelected = (id) => {
        return this.state.documentsCompanyTypes.filter((item) => (item.id === id)).length;
    }

    validateDocument = (e) => {
        let documents = this.state.documentsCompanyTypes.filter((i) => (i.id == e.target.id));

        let qtdDate = '';
        let calendarDate = 'day';
        let dataValidity = documents[0].DocumentToCompanyTypes[0].defaultValidity;

        if (dataValidity) {

            let day = dataValidity.indexOf("days");
            let week = dataValidity.indexOf("weeks");
            let month = dataValidity.indexOf("months");
            let year = dataValidity.indexOf("years");

            if (day != -1) {
                calendarDate = 'days';
            }else if (week != -1) {
                calendarDate = 'weeks';
            }else if (month != -1) {
                calendarDate = 'months';
            }else if (year != -1) {
                calendarDate = 'years';
            }

            qtdDate = dataValidity.split('-');
        }
        this.setState({ titleDocumentValidate: documents[0].description, idDocumentValidate: e.target.id, updateDate: false });

        document.getElementById('qtdDate').value = qtdDate[0];
        document.getElementById('calendarDate').value = calendarDate;
    }

    ValidadeCalendar = () => {
        let calendarDate = document.getElementById('calendarDate').value;
        let qtdDate = document.getElementById('qtdDate').value;
        if (calendarDate != '' && qtdDate != '') {
            this.setState({ isValidadeCalendar: false });
        } else {
            this.setState({ isValidadeCalendar: true });
        }
    }

    updateDateDocument = async (e) => {
        let companyType = this.state.idCompanyTypes;
        let documentId = this.state.idDocumentValidate;
        let qtdDate = document.getElementById('qtdDate').value;
        let calendarDate = document.getElementById('calendarDate').value;

        let response = await api.put(`/company-types/${companyType}/documents/${documentId}`, { defaultValidity: (qtdDate +'-'+ calendarDate) });
        if (response.data.updated) {
            this.loadDocumentsDocumentTypes();
            this.setState({ updateDate: true });
            setTimeout(() => {
                document.getElementById('closeModal').click();
            }, 5000);
        }
    }

    handleUpdateStatusesChange = (e) => {
        if (e.target.checked) {
            this.setState({ showConfirmation: true });
        } else {
            this.setState({ updateStatuses: false });
        }
    }

    confirmUpdateStatuses = () => {
        this.setState({ 
            updateStatuses: true,
            showConfirmation: false 
        });
    }

    cancelUpdateStatuses = () => {
        this.setState({ 
            updateStatuses: false,
            showConfirmation: false 
        });
    }

    render() {
        return (
            <Fragment>
                <div className="row page-titles">
                    <div className="col-md-5 col-8 align-self-center">
                        <h3 className="text-themecolor">Configuração
                        {(this.state.load) ? <i className="fa fa-spin fa-spinner"></i> : null}
                        </h3>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <h5>Tipos de Documento</h5>
                        <div className="row">
                            {
                                (this.state.documentTypes.length) ?
                                    this.state.documentTypes.map((item) => {
                                        return (
                                            <div className="col-md-4" key={item.id}>
                                                <input name="tipo" type="radio" id={'tipo'+item.id} value={item.id} onClick={this.TypeCompany} className="with-gap radio-col-light-blue" />
                                                <label htmlFor={'tipo'+item.id}>{item.description}</label>
                                            </div>
                                        )
                                    })
                                    : null
                            }
                        </div>
                    </div>
                    <div className="col-md-12">
                        <br />
                        <h5>Tipos de Empresa</h5>
                        <div className="row">
                            {
                                (this.state.companyTypes.length) ?
                                    this.state.companyTypes.map((item) => {
                                        return (
                                            <div key={item.id} className="col-md-4 m-b-10">
                                                <button onClick={this.TypeDocuments} disabled={(!this.state.idType)} className="col-md-12 btn waves-effect waves-light btn-rounded btn-primary" key={item.id} value={item.id}>
                                                    {item.description}
                                                </button>
                                            </div>
                                        )
                                    })
                                    : null
                            }
                        </div>
                    </div>

                    {(this.state.idCompanyTypes) ?
                        <div className="col-md-12">
                            <br />
                            <div className="card">
                                <h5 className="p-10 text-themecolor">Lista de documentos</h5>
                                <table className="table table-border">
                                    <tbody>
                                        {
                                            (this.state.documentsCompanyTypes.length) ?
                                                this.state.documentsCompanyTypes.map((item) => {
                                                    return (
                                                        <tr key={item.id}>
                                                            <td>{item.description}</td>
                                                            <td className="td-button" id={item.id} onClick={this.deleteDocument}>
                                                                <button type="button" className="btn btn-sm btn-outline-danger btn-circle" id={item.id}><i className="fa fa-times" id={item.id}></i> </button>
                                                            </td>
                                                            <td className="td-button">
                                                                <button type="button" id={item.id} onClick={this.validateDocument} data-toggle="modal" data-target=".modal-validade-date" className="btn btn-sm btn-outline-secondary btn-circle">
                                                                    <i id={item.id} className="fa fa-calendar"></i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                                : <tr><td><div className="text-center p-20">Nenhum documento adicionado</div></td></tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                            <button onClick={this.addListDocuments} className="col-md-4 btn waves-effect waves-light btn-rounded btn-success" data-toggle="modal" data-target=".bs-example-modal-lg">
                                Adicionar Documentos
                            </button>

                            {/* <button onClick={this.addListDocuments} className="col-md-4 btn waves-effect waves-light btn-rounded btn-danger" data-toggle="modal" data-target=".abcdef">
                                Teste Dividir Componentes
                            </button> */}

                        </div>
                        : null}

                </div>

                <div className="modal fade bs-example-modal-lg" data-backdrop="static" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="myLargeModalLabel">Documentos
                                {(this.state.load) ? <i className="fa fa-spin fa-spinner"></i> : null}
                                </h5>
                                <button type="button" className="close" data-dismiss="modal" aria-hidden="true">×</button>
                            </div>
                            <div className="modal-body">
                                <div>
                                    {(this.state.functions.length) ?
                                        <div>
                                            <h5>Função</h5>
                                            <select className="custom-select col-12" id="functions" onChange={this.filterDocumentsFunction}>
                                                <option value="">Todas</option>
                                                {
                                                    (this.state.functions.length) ?
                                                        this.state.functions.map((item, index) => {
                                                            return (
                                                                <option key={index} value={item.id}>{item.description}</option>
                                                            )
                                                        })
                                                        : null
                                                }
                                            </select>
                                            <hr />
                                        </div>
                                        : null}

                                    
                                    {
                                        (this.state.documentsCompanyTypesId.length) ?
                                            this.state.documentsCompanyTypesId.map((item) => {
                                                return (
                                                    <div key={item.id} className="col-md-12 p-10">
                                                        {(!this.verifyDocumentSelected(item.id)) ?
                                                            <input type="checkbox" name="documents" value={item.id} id={'document_' + item.id} onClick={this.checkDocument} />
                                                            : null
                                                        }
                                                        <label className={(this.verifyDocumentSelected(item.id)) ? 'text-success' : null} htmlFor={'document_' + item.id}> {item.description} </label>
                                                    </div>

                                                )
                                            })
                                            : <div className="text-center p-20">Nenhum documento para adicionar</div>
                                    }

                                </div>

                                {(this.state.successDocuments) ?
                                    <div className="alert alert-success">Documento(s) inserido(s) com sucesso!</div>
                                    : null}

                            </div>
                            <div className="modal-footer">
                                <div className="row w-100">
                                    <div className="col-md-12 mb-3 text-center">
                                        <div className="alert alert-warning d-inline-block mb-0">
                                            <div className="custom-control custom-checkbox">
                                                <input 
                                                    type="checkbox" 
                                                    className="custom-control-input" 
                                                    id="updateStatuses" 
                                                    checked={this.state.updateStatuses}
                                                    onChange={this.handleUpdateStatusesChange}
                                                />
                                                <label className="custom-control-label" htmlFor="updateStatuses">
                                                    Atualizar status das empresas/funcionários
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12 text-right">
                                        <button className="btn waves-effect waves-light btn-rounded btn-success mr-2" onClick={this.submitCheckDocument}>
                                            Adicionar
                                        </button>
                                        <button type="button" className="btn btn-secondary btn-rounded waves-effect" data-dismiss="modal">
                                            Fechar
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Confirmation Modal */}
                <div className={`modal fade ${this.state.showConfirmation ? 'show' : ''}`} 
                    style={{ 
                        display: this.state.showConfirmation ? 'block' : 'none',
                        backgroundColor: this.state.showConfirmation ? 'rgba(0,0,0,0.5)' : 'transparent'
                    }} 
                    tabIndex="-1" 
                    role="dialog">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Confirmação</h5>
                                <button type="button" className="close" onClick={this.cancelUpdateStatuses}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <p>Essa ação vai afetar o status de vários registros, deseja continuar?</p>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={this.cancelUpdateStatuses}>Cancelar</button>
                                <button type="button" className="btn btn-success" onClick={this.confirmUpdateStatuses}>Continuar</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade modal-validade-date" data-backdrop="static" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-sm">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="myLargeModalLabel">Validade
                                {(this.state.load) ? <i className="fa fa-spin fa-spinner"></i> : null}
                                </h5>
                                <button type="button" className="close" data-dismiss="modal" aria-hidden="true">×</button>
                            </div>
                            <div className="modal-body row">
                                <div className="col-md-12">
                                    {(this.state.updateDate) ?
                                        <div className="alert alert-success">
                                            Atualizado com sucesso!
                                    </div>
                                        : null}
                                    <span>{this.state.titleDocumentValidate}</span>
                                </div>
                                <div className="col-md-4">
                                    <input type="number" id="qtdDate" onChange={this.ValidadeCalendar} className="form-control col-12" min="1" />
                                </div>
                                <div className="col-md-8">
                                    <select id="calendarDate" onChange={this.ValidadeCalendar} className="custom-select col-12">
                                        <option value="days">Dia(s)</option>
                                        <option value="weeks">Semana(s)</option>
                                        <option value="months">Mes(es)</option>
                                        <option value="years">Ano(s)</option>
                                    </select>
                                </div>
                            </div>
                            <div className="modal-footer">
                                {(!this.state.updateDate) ?
                                    <button onClick={this.updateDateDocument} disabled={this.state.isValidadeCalendar} className="col-md-6 btn waves-effect waves-light btn-rounded btn-success">
                                        Salvar
                                    </button>
                                    : null}
                                <button type="button" id="closeModal" className="col-md-6 btn btn-secondary btn-rounded waves-effect" data-dismiss="modal">Fechar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment >
        )
    }

}

export default Configuration;